import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import { useShowBackButton } from '../../hooks/useBackButton'

import Title from '../../components/ui/title/title'
import usePageLoaded from '../../hooks/usePageLoaded'
import WalletPoints from '../../components/profile/wallet/WalletPoints'

import { GiftConstructor } from '../../components/profile/wallet/notSentGift/NotSentGift'
import { createLocalizedPath } from '../../utils/localizationHelpers'
import { getLangFromPath } from '../../i18next'
import { Helmet } from 'react-helmet'
import { META } from '../../constants/meta'
import './../profile/virtualGifts.sass'
import { getGiftCatalog, Gift } from '../../api/gifts'
import PaginationWrapper from '../../components/pagination/paginationWrapper'
import { fetchProfile } from '../../store/profile/profileSlice'
import { addLocationToString } from '../../utils/meta'
import { useSelector } from 'react-redux'
import { RootState } from '../../store/rootReducer'
import { ProfileState } from '../../store/profile/profileTypings'

const VirtualGiftCatalog = () => {
    usePageLoaded()
    useShowBackButton()

    const [t] = useTranslation()
    const location = useLocation()
    const { user } = useSelector<RootState, ProfileState>((state) => state.profile)

    const getUserFromUrl = () => new URLSearchParams(location.search).get('r')

    const giftRecipient = useRef(getUserFromUrl())
    const [currentPage, setCurrentPage] = useState(1)
    const [giftsList, setGiftsList] = useState(null)

    const totalGifts = useRef(null)

    useEffect(() => {
        getGiftCatalog({ limit: 20, p: currentPage })
            .then((res) => {
                setGiftsList(res.list)
                totalGifts.current = res.total_count
            })
            .catch((e) => console.log(e))
    }, [])

    return (
        <div className="pageContent" style={{ margin: '0 auto', maxWidth: '1360px', padding: '90px 27px' }}>
            <Helmet>
                <title>
                    {addLocationToString(
                        META.giftsCatalog[getLangFromPath(location.pathname)].title.replace(
                            '{NICK}',
                            giftRecipient.current
                        ),
                        user
                    )}
                </title>
                <meta
                    name="description"
                    content={addLocationToString(
                        META.giftsCatalog[getLangFromPath(location.pathname)].description.replace(
                            '{NICK}',
                            giftRecipient.current
                        ),
                        user
                    )}
                />
            </Helmet>
            <Title text={t('Give a virtual gift to') + giftRecipient.current} />
            <div className={'giftLinkToProfile'}>
                <Link to={{ pathname: createLocalizedPath(`/profil/${giftRecipient.current}`) }} className={'nickLink'}>
                    {t('Back to profile of') + giftRecipient.current}
                </Link>
                <WalletPoints />
            </div>
            <div className={'giftsWrapper'}>
                {giftsList &&
                    giftsList.map((item: Gift) => (
                        // @ts-ignore
                        <GiftConstructor giftInfo={item} catalog key={item.gift_id} recipient={giftRecipient.current} />
                    ))}
            </div>
            {totalGifts.current > 20 && (
                <PaginationWrapper
                    limit={20}
                    limitOptions={20}
                    maxButtons={5}
                    activePage={currentPage}
                    onchange={(page: number) => {
                        setCurrentPage(page)
                    }}
                    total={totalGifts.current}
                />
            )}
        </div>
    )
}

// @ts-ignore
VirtualGiftCatalog.getInitialProps = async ({ store, location, req }) => {
    const nick = req ? req.query.r : new URLSearchParams(location.search).get('r')
    await store.dispatch(fetchProfile({ nick }))
}

export default VirtualGiftCatalog
